const team = [
  {
    name: "Harsh Gandhi",
    title: "Founder",
    location: "Ahmedabad",
    initials: "HG",
    accent: "#E26D5C",
  },
];

export default function Team() {
  return (
    <section
      id="team"
      data-testid="team-section"
      className="scroll-mt-24 bg-[#F7F5F0] py-24 md:py-40 border-t border-[#D8D4C7]"
    >
      <div className="max-w-screen-2xl mx-auto px-6 md:px-12">
        <div className="grid md:grid-cols-12 gap-12 mb-16 md:mb-20">
          <div className="md:col-span-3 reveal">
            <span className="text-xs font-bold uppercase tracking-[0.25em] text-[#5C5C58]">
              (05) · The people
            </span>
            <div className="mt-6 w-12 h-px bg-[#1C1C19]" />
          </div>
          <div className="md:col-span-9 reveal">
            <h2 className="font-display text-4xl sm:text-5xl lg:text-7xl font-light tracking-tight leading-[1.05]">
              Operators &amp; strategists
              <br />
              <span className="italic text-[#729B79]">
                who've shipped the work.
              </span>
            </h2>
            <p className="mt-8 max-w-2xl text-base md:text-lg font-light text-[#1C1C19]/70">
              GroundWork is led by Harsh, working with a small, hand-picked
              network of senior specialists across brand, creative and growth.
              The network is assembled around each engagement, so the right
              people are brought in for the work rather than maintained as fixed
              overhead.
            </p>
          </div>
        </div>

        <div className="flex justify-center">
          {team.map((m, i) => (
            <figure
              key={m.name}
              data-testid={`team-member-${i + 1}`}
              className="reveal group w-full max-w-[240px] sm:max-w-xs text-center"
            >
              {/* Portrait placeholder sized for a real headshot; smaller on mobile */}
              <div
                className="relative aspect-[3/4] overflow-hidden rounded-2xl flex items-center justify-center"
                style={{ background: m.accent }}
              >
                <span className="font-display text-6xl sm:text-7xl font-light text-[#F7F5F0]/90 leading-none">
                  {m.initials}
                </span>
                <span className="absolute bottom-4 left-4 text-[10px] uppercase tracking-[0.25em] text-[#F7F5F0]/90">
                  {m.location}
                </span>
              </div>

              <figcaption className="mt-5">
                <h3 className="font-display text-2xl md:text-3xl text-[#1C1C19] font-light leading-tight">
                  {m.name}
                </h3>
                <p className="mt-2 text-xs uppercase tracking-[0.2em] text-[#5C5C58] leading-relaxed">
                  {m.title}
                </p>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
